import { tealium } from '@rcg/ui-analytics';
export const trackEvent = userInteractionEvent => {
  tealium.trackEvent(userInteractionEvent);
};
export const trackPage = dataPage => {
  tealium.trackPage(dataPage);
};
